document.addEventListener('DOMContentLoaded', () => {
  
  // === 1. THE TELEPORTER ===
  try {
    const lightbox = document.getElementById('sircable-lightbox');
    const sizeDrawer = document.getElementById('sircable-size-drawer');
    const stickyAtc = document.getElementById('sircable-sticky-atc');
    if (lightbox) document.body.appendChild(lightbox);
    if (sizeDrawer) document.body.appendChild(sizeDrawer);
    if (stickyAtc) document.body.appendChild(stickyAtc);
  } catch (e) { console.error("Teleport Error:", e); }

  // === SWIPE NAVIGATION (mobile/touch) ===
  let sircableSwiped = false;
  let mainGallery = null;

  // === LIGHTBOX CAROUSEL (filmstrip; infinite loop + finger-tracked peek) ===
  const LB_DUR = 420; // must match the CSS transition duration below
  const lbMainEl   = document.getElementById('sircable-lightbox-main');
  const lbViewport = document.getElementById('sircable-lb-viewport');
  const lbTrack    = document.getElementById('sircable-lb-track');
  const lbCountEl  = document.getElementById('sircable-lb-current');
  const lbTotalEl  = document.getElementById('sircable-lb-total');

  // Desktop magnifier: while zoomed, the image pans to follow the cursor.
  if (lbViewport && lbMainEl) {
    lbViewport.addEventListener('mousemove', function (e) {
      if (!lbMainEl.classList.contains('is-zoomed')) return;
      const r = lbViewport.getBoundingClientRect();
      const ox = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width  * 100));
      const oy = Math.max(0, Math.min(100, (e.clientY - r.top)  / r.height * 100));
      lbMainEl.style.setProperty('--lb-ox', ox + '%');
      lbMainEl.style.setProperty('--lb-oy', oy + '%');
    }, { passive: true });
  }

  // Esc closes the zoom lightbox (same teardown as the X button).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    const lb = document.getElementById('sircable-lightbox');
    if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.remove('is-open'); lb.style.background = ''; lb.style.opacity = ''; lb.style.transition = '';
    window.SircableScrollLock.unlock('lightbox');
    if (lbMainEl) { lbMainEl.classList.remove('is-zoomed'); lbMainEl.style.transform = ''; lbMainEl.style.transition = ''; }
  });

  let lbSlides = lbTrack ? Array.from(lbTrack.children) : [];
  const lbReal = lbSlides.length;
  const lbLoop = lbReal > 1;
  let lbSnapTimer = null;

  // Clone first & last slides so the strip can wrap seamlessly (no rewind blur)
  if (lbTrack && lbLoop) {
    const firstClone = lbSlides[0].cloneNode(true);
    const lastClone  = lbSlides[lbReal - 1].cloneNode(true);
    lbTrack.appendChild(firstClone);
    lbTrack.insertBefore(lastClone, lbSlides[0]);
    lbSlides = Array.from(lbTrack.children); // now lbReal + 2 children
  }

  let lbPos = lbLoop ? 1 : 0; // first real slide sits at position 1 when looping
  if (lbTotalEl) lbTotalEl.textContent = lbReal;

  // getBoundingClientRect returns sub-pixel precision — prevents fractional drift
  function lbWidth() { return lbViewport ? lbViewport.getBoundingClientRect().width : window.innerWidth; }

  function lbRealIndex() {
    if (!lbLoop) return 0;
    if (lbPos === 0) return lbReal - 1;        // on the last-clone
    if (lbPos === lbReal + 1) return 0;        // on the first-clone
    return lbPos - 1;
  }

  function lbApply(animate, dragPx) {
    if (!lbTrack) return;
    lbTrack.style.transition = animate ? 'transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
    lbTrack.style.transform = 'translateX(' + (-lbPos * lbWidth() + (dragPx || 0)) + 'px)';
  }

  function lbSync() {
    // Sync the main gallery to match the current lightbox slide.
    // goTo() inside initMainGallery handles the variant + colour swatch sync
    // so we only need to point the main gallery at the right image here.
    const slide = lbSlides[lbPos];
    const img = slide && slide.querySelector('img');
    if (!img) return;
    updateMainImage(img.getAttribute('src') || '');
  }

  function lbUpdateUI() {
    const ri = lbRealIndex();
    const thumbs = document.querySelectorAll('.sircable-lightbox__thumb');
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === ri));
    if (lbCountEl) lbCountEl.textContent = ri + 1;
    if (thumbs[ri]) thumbs[ri].scrollIntoView({ block: 'nearest', inline: 'center' });
  }

  function lbGoToPos(pos, animate) {
    if (!lbSlides.length) return;
    lbPos = pos;
    if (lbMainEl) lbMainEl.classList.remove('is-zoomed');
    lbApply(animate, 0);
    lbUpdateUI();
    lbSync();
    // After sliding onto a clone, silently jump to the matching real slide
    if (lbLoop && animate) {
      if (lbSnapTimer) { clearTimeout(lbSnapTimer); lbSnapTimer = null; }
      if (lbPos === lbReal + 1) {
        lbSnapTimer = setTimeout(() => { lbPos = 1; lbApply(false, 0); lbSnapTimer = null; }, LB_DUR);
      } else if (lbPos === 0) {
        lbSnapTimer = setTimeout(() => { lbPos = lbReal; lbApply(false, 0); lbSnapTimer = null; }, LB_DUR);
      }
    }
  }

  function lbStep(delta) {
    if (!lbLoop) return;
    if (lbSnapTimer) { clearTimeout(lbSnapTimer); lbSnapTimer = null; }
    if (lbPos === lbReal + 1) { lbPos = 1; lbApply(false, 0); }
    else if (lbPos === 0) { lbPos = lbReal; lbApply(false, 0); }
    lbGoToPos(lbPos + delta, true);
  }

  function lbGoToReal(realIdx, animate) {
    if (lbSnapTimer) { clearTimeout(lbSnapTimer); lbSnapTimer = null; }
    lbGoToPos(lbLoop ? realIdx + 1 : 0, animate);
  }

  function lbOpenAt(realIdx) {
    if (lbSnapTimer) { clearTimeout(lbSnapTimer); lbSnapTimer = null; }
    lbPos = lbLoop ? (realIdx + 1) : 0;
    if (lbMainEl) { lbMainEl.classList.remove('is-zoomed'); lbMainEl.style.transform = ''; lbMainEl.style.transition = ''; }
    const lbFull = document.getElementById('sircable-lightbox');
    if (lbFull) { lbFull.style.background = ''; lbFull.style.opacity = ''; lbFull.style.transition = ''; }
    lbSwipeDown = false; lbDragY = 0;
    lbApply(false, 0);
    lbUpdateUI();
    // GPU pre-warm strategy:
    //   Phase 1 (immediate) — decode current slide + 2 neighbours so the first
    //   few swipes render without a flash.
    //   Phase 2 (1 s delay) — decode the rest while the user looks at the first
    //   image; zero impact on perceived open speed.
    // img.decode() goes beyond new Image(): it waits for compressed bytes to be
    // fully rasterised into a GPU texture, eliminating black flashes for large PNGs.
    if (lbTrack) {
      const decodeImg = img => {
        if (!img) return;
        img.loading = 'eager';
        const go = () => img.decode && img.decode().catch(() => {});
        img.complete ? go() : img.addEventListener('load', go, { once: true });
      };
      // Phase 1: current slide ± 2
      [-2, -1, 0, 1, 2].forEach(d => {
        const i = ((lbPos + d) % lbSlides.length + lbSlides.length) % lbSlides.length;
        decodeImg(lbSlides[i] && lbSlides[i].querySelector('img'));
      });
      // Phase 2: all remaining — once per page load
      if (!lbTrack._lbBgLoaded) {
        lbTrack._lbBgLoaded = true;
        setTimeout(() => {
          lbSlides.forEach(slide => decodeImg(slide.querySelector('img')));
        }, 1000);
      }
    }
  }

  // lbSwipeDown / lbDragY track the swipe-to-close gesture (accessible from close handler too)
  let lbSwipeDown = false;
  let lbDragY = 0;

  if (lbViewport) {
    let sx = 0, sy = 0, drag = false, dxv = 0, decided = false;

    lbViewport.addEventListener('touchstart', (ev) => {
      if (ev.touches.length !== 1) return;
      if (lbMainEl && lbMainEl.classList.contains('is-zoomed')) return;
      sx = ev.touches[0].clientX; sy = ev.touches[0].clientY;
      drag = lbLoop; // horizontal navigation only makes sense with multiple slides
      dxv = 0; decided = false; lbSwipeDown = false; lbDragY = 0;
    }, { passive: true });

    lbViewport.addEventListener('touchmove', (ev) => {
      const ddx = ev.touches[0].clientX - sx;
      const ddy = ev.touches[0].clientY - sy;
      if (!decided) {
        if (Math.abs(ddx) < 10 && Math.abs(ddy) < 10) return; // wait for clear intent
        decided = true;
        if (Math.abs(ddy) > Math.abs(ddx)) {
          drag = false;
          lbSwipeDown = ddy > 0; // downward only → swipe-to-close; upward → just block scroll
        }
        // horizontal: drag stays true if lbLoop
      }
      ev.preventDefault(); // block page scroll for any decided gesture (fixes page bleed-through)

      if (lbSwipeDown) {
        lbDragY = Math.max(0, ddy);
        if (lbMainEl) lbMainEl.style.transform = `translateY(${lbDragY * 0.85}px)`;
        const lbEl = document.getElementById('sircable-lightbox');
        if (lbEl) lbEl.style.background = `rgba(0,0,0,${Math.max(0.05, 0.93 - lbDragY / 280)})`;
        return;
      }
      if (drag) { dxv = ddx; lbApply(false, dxv); }
    }, { passive: false });

    lbViewport.addEventListener('touchend', () => {
      if (lbSwipeDown) {
        lbSwipeDown = false;
        if (lbDragY > 110) {
          // Dismiss — fly off screen
          if (lbMainEl) {
            lbMainEl.style.transition = 'transform 0.28s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            lbMainEl.style.transform = `translateY(${window.innerHeight}px)`;
          }
          const lbEl = document.getElementById('sircable-lightbox');
          if (lbEl) { lbEl.style.transition = 'opacity 0.28s ease'; lbEl.style.opacity = '0'; }
          setTimeout(() => {
            const lb = document.getElementById('sircable-lightbox');
            if (lb) { lb.classList.remove('is-open'); lb.style.transition = ''; lb.style.opacity = ''; lb.style.background = ''; }
            window.SircableScrollLock.unlock('lightbox');
            if (lbMainEl) { lbMainEl.classList.remove('is-zoomed'); lbMainEl.style.transition = ''; lbMainEl.style.transform = ''; }
          }, 300);
        } else {
          // Spring back
          if (lbMainEl) {
            lbMainEl.style.transition = 'transform 0.32s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            lbMainEl.style.transform = 'translateY(0)';
            setTimeout(() => { if (lbMainEl) { lbMainEl.style.transition = ''; lbMainEl.style.transform = ''; } }, 340);
          }
          const lbEl = document.getElementById('sircable-lightbox');
          if (lbEl) lbEl.style.background = '';
        }
        lbDragY = 0;
        return;
      }
      if (!drag) return;
      drag = false;
      const threshold = lbWidth() * 0.16;
      if (dxv < -threshold) { sircableSwiped = true; lbStep(1); }
      else if (dxv > threshold) { sircableSwiped = true; lbStep(-1); }
      else { lbApply(true, 0); }
      dxv = 0;
    }, { passive: true });
  }

  window.addEventListener('resize', () => lbApply(false, 0));

  // Catch-all: block background page scroll whenever the lightbox is open.
  // The viewport listener above covers horizontal/vertical swipes on the image,
  // but touches on the counter bar or edges would still pass through without this.
  const lbOverlay = document.getElementById('sircable-lightbox');
  if (lbOverlay) {
    lbOverlay.addEventListener('touchmove', (ev) => {
      if (!lbOverlay.classList.contains('is-open')) return;
      if (ev.target.closest('.sircable-lightbox__tray')) return; // allow thumb tray horizontal scroll
      ev.preventDefault();
    }, { passive: false });
  }

  // === MAIN GALLERY: filmstrip track init ===
  function initMainGallery() {
    const viewport = document.getElementById('main-image-container');
    const track    = document.getElementById('sircable-main-track');
    if (!viewport || !track) return null;

    const slides = Array.from(track.children);
    const total  = slides.length;
    if (total === 0) return null;

    // Preload all slides immediately — lazy-loaded images off-screen via
    // overflow:hidden won't load on their own, causing white frames on navigate.
    slides.forEach(slide => {
      const img = slide.querySelector('img');
      if (!img) return;
      img.loading = 'eager';
      // img.decode() rasterises the image into a GPU texture so it paints
      // instantly when scrolled into view — no new Image() download-only trick.
      const go = () => img.decode && img.decode().catch(() => {});
      img.complete ? go() : img.addEventListener('load', go, { once: true });
    });

    let pos = 0;

    // getBoundingClientRect gives sub-pixel precision — avoids integer-rounding
    // drift and the border-inclusion issue with offsetWidth on desktop.
    function w() { return slides[0] ? slides[0].getBoundingClientRect().width : viewport.getBoundingClientRect().width; }

    function apply(animate, dragPx) {
      track.style.transition = animate
        ? 'transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';
      track.style.transform = 'translateX(' + (-pos * w() + (dragPx || 0)) + 'px)';
    }

    function syncThumbs(animate) {
      const thumbs = document.querySelectorAll('.product-gallery__thumb');
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === pos));
      if (thumbs[pos] && window.innerWidth <= 768) {
        thumbs[pos].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    // Guard that prevents goTo → updateVariantSelections → updateMainImage → goTo
    // from looping. Set true before entering the sync block; goTo re-entry skips it.
    let _syncBusy = false;

    function goTo(idx) {
      pos = ((idx % total) + total) % total;
      apply(true, 0);
      syncThumbs();
      // Sync the color swatch to the image now showing.
      // _syncBusy breaks the feedback loop:
      //   goTo → updateVariantSelections → updateMainImage → goTo (re-entry skipped)
      if (!_syncBusy && typeof productVariants !== 'undefined' && productVariants.length > 0) {
        const curImg = slides[pos] && slides[pos].querySelector('img');
        if (curImg) {
          const base = (curImg.getAttribute('src') || '').split('?')[0];
          if (base) {
            const matched = productVariants.find(v =>
              v.featured_image && v.featured_image.src && v.featured_image.src.includes(base)
            );
            if (matched) {
              _syncBusy = true;
              optionContainers.forEach(c => {
                const optName = c.getAttribute('data-option-name');
                const rawName = c.getAttribute('data-raw-name');
                const val = matched[optName];
                if (val && rawName && rawName.includes('color')) {
                  c.querySelectorAll('.product-option__btn').forEach(b => b.classList.remove('is-active'));
                  const target = Array.from(c.querySelectorAll('.product-option__btn'))
                    .find(b => b.getAttribute('data-value') === val);
                  if (target) {
                    target.classList.add('is-active');
                    const lbl = document.getElementById(target.dataset.target);
                    if (lbl) lbl.textContent = val;
                  }
                }
              });
              updateVariantSelections();
              _syncBusy = false;
            }
          }
        }
      }
    }

    function next() { goTo(pos + 1); }
    function prev() { goTo(pos - 1); }

    // Touch swipe — track-based (filmstrip follows finger in real time)
    let sx = 0, sy = 0, drag = false, dx = 0, decided = false;

    track.addEventListener('touchstart', (ev) => {
      if (ev.touches.length !== 1) return;
      sx = ev.touches[0].clientX;
      sy = ev.touches[0].clientY;
      drag = true; dx = 0; decided = false;
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', (ev) => {
      if (!drag) return;
      const ddx = ev.touches[0].clientX - sx;
      const ddy = ev.touches[0].clientY - sy;
      if (!decided) {
        if (Math.abs(ddx) < 8 && Math.abs(ddy) < 8) return;
        decided = true;
        if (Math.abs(ddx) < Math.abs(ddy)) { drag = false; return; }
      }
      ev.preventDefault();
      dx = ddx;
      track.style.transform = 'translateX(' + (-pos * w() + dx) + 'px)';
    }, { passive: false });

    track.addEventListener('touchend', () => {
      if (!drag) return;
      drag = false;
      const threshold = w() * 0.16;
      if (Math.abs(dx) > threshold) {
        sircableSwiped = true;
        dx < 0 ? next() : prev();
      } else {
        apply(true, 0); // snap back
      }
      dx = 0;
    }, { passive: true });

    window.addEventListener('resize', () => apply(false, 0));

    apply(false, 0);
    syncThumbs();

    return { goTo, next, prev, getPos: () => pos };
  }

  mainGallery = initMainGallery();

  // === 2. THE VARIANT ENGINE ===
  const productJsonEl = document.getElementById('SircableProductJSON');
  let productVariants = [];
  if (productJsonEl) {
    try { productVariants = JSON.parse(productJsonEl.textContent); } 
    catch (e) { console.error("JSON Error:", e); }
  }

  const hiddenInput = document.getElementById('hidden-variant-id');
  const priceDisplay = document.getElementById('product-price-display');
  const atcButton = document.getElementById('add-to-cart-button');
  const optionContainers = document.querySelectorAll('.product-option__values');

  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function updateMainImage(newSrc) {
    if (!mainGallery || !newSrc) return;
    const base = newSrc.split('?')[0];
    const slides = document.querySelectorAll('#sircable-main-track .sircable-main-slide');
    let idx = 0;
    slides.forEach((slide, i) => {
      const img = slide.querySelector('img');
      const imgBase = img ? (img.getAttribute('src') || '').split('?')[0] : '';
      if (imgBase && imgBase === base) idx = i;
    });
    mainGallery.goTo(idx);
  }

  function updateVariantSelections() {
    if (productVariants.length === 0) return;
    try {
      let currentSelections = { option1: null, option2: null, option3: null };
      
      optionContainers.forEach(container => {
        const activeBtn = container.querySelector('.product-option__btn.is-active');
        if (activeBtn) {
          const optName = container.getAttribute('data-option-name');
          currentSelections[optName] = activeBtn.getAttribute('data-value');
        }
      });

      const allButtons = document.querySelectorAll('.product-option__btn');
      allButtons.forEach(btn => {
        btn.classList.add('is-unavailable');
        const optionName = btn.closest('.product-option__values').getAttribute('data-option-name');
        const optionValue = btn.getAttribute('data-value');
        
        let testSelections = { ...currentSelections };
        testSelections[optionName] = optionValue;

        const isAvailable = productVariants.some(variant => {
          return variant.available && 
                 (!testSelections.option1 || variant.option1 === testSelections.option1) &&
                 (!testSelections.option2 || variant.option2 === testSelections.option2) &&
                 (!testSelections.option3 || variant.option3 === testSelections.option3);
        });

        if (isAvailable) btn.classList.remove('is-unavailable');
      });

      const matchedVariant = productVariants.find(variant => {
        return variant.option1 === currentSelections.option1 &&
               variant.option2 === currentSelections.option2 &&
               variant.option3 === currentSelections.option3;
      });

      if (matchedVariant) {
        if (hiddenInput) hiddenInput.value = matchedVariant.id;
        
        if (priceDisplay) {
          const salePct = window.SircableSalePct || 0;
          if (matchedVariant.compare_at_price > matchedVariant.price) {
            const savings = Math.round((matchedVariant.compare_at_price - matchedVariant.price) * 100 / matchedVariant.compare_at_price);
            priceDisplay.innerHTML = `<span class="product-info__price-compare">${formatMoney(matchedVariant.compare_at_price)}</span><span class="product-info__price-current product-info__price--sale">${formatMoney(matchedVariant.price)}</span><span class="sircable-sale-badge" id="pdp-sale-badge">SAVE ${savings}%</span>`;
          } else if (salePct > 0) {
            const salePrice = Math.round(matchedVariant.price * (100 - salePct) / 100);
            priceDisplay.innerHTML = `<span class="product-info__price-compare">${formatMoney(matchedVariant.price)}</span><span class="product-info__price-current product-info__price--sale">${formatMoney(salePrice)}</span><span class="sircable-sale-badge" id="pdp-sale-badge">${salePct}% OFF</span>`;
          } else {
            priceDisplay.innerHTML = `<span class="product-info__price-current">${formatMoney(matchedVariant.price)}</span>`;
          }
        }

        if (atcButton) {
          if (matchedVariant.available) {
            atcButton.removeAttribute('disabled');
            const salePct = window.SircableSalePct || 0;
            const displayPrice = (salePct > 0 && !(matchedVariant.compare_at_price > matchedVariant.price))
              ? Math.round(matchedVariant.price * (100 - salePct) / 100)
              : matchedVariant.price;
            atcButton.innerHTML = `Add to cart — <span id="atc-btn-price">${formatMoney(displayPrice)}</span>`;
          } else {
            atcButton.setAttribute('disabled', 'true');
            atcButton.textContent = 'Sold out';
          }
        }

        if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
          updateMainImage(matchedVariant.featured_image.src);
          const thumbs = document.querySelectorAll('.product-gallery__thumb');
          const targetBase = matchedVariant.featured_image.src.split('?')[0];
          thumbs.forEach(thumb => {
            thumb.classList.remove('is-active');
            const thumbSrc = thumb.getAttribute('data-src');
            if (thumbSrc && thumbSrc.includes(targetBase)) {
              thumb.classList.add('is-active');
              if (window.innerWidth <= 768) {
                thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
              }
            }
          });
        }
      }
    } catch (err) { console.error('Variant Sync Error:', err); }
  }

  updateVariantSelections();

  // === STICKY MOBILE ADD-TO-CART BAR ===
  // Mirrors the real price/button (single source of truth via MutationObserver
  // — no variant logic duplicated), proxies clicks to the real button (rides
  // the existing /cart/add.js AJAX flow in sircable-carts.js untouched), and
  // only reveals itself once the shopper scrolls past the real ATC button —
  // so it stays out of the way until it's actually useful.
  try {
    const stickyBar   = document.getElementById('sircable-sticky-atc');
    const stickyPrice = document.getElementById('sircable-sticky-atc-price');
    const stickyBtn   = document.getElementById('sircable-sticky-atc-btn');
    const atcWrap     = document.querySelector('.product-atc');

    if (stickyBar && stickyBtn && atcButton) {
      const syncStickyAtc = () => {
        if (stickyPrice && priceDisplay) stickyPrice.innerHTML = priceDisplay.innerHTML;
        // Distinguish a temporary loading-disabled from a genuine sold-out.
        // sircable-carts.js always sets innerHTML to 'ADDING...' before it sets
        // disabled=true during the AJAX request, so we can sniff that text here.
        const isLoading = atcButton.textContent.trim().toUpperCase().includes('ADDING');
        const soldOut   = !isLoading && atcButton.disabled;
        stickyBtn.disabled = soldOut || isLoading;
        stickyBtn.textContent = isLoading ? 'Adding...' : soldOut ? 'Sold out' : 'Add to cart';
      };
      syncStickyAtc();

      new MutationObserver(syncStickyAtc).observe(atcButton, { attributes: true, attributeFilter: ['disabled'] });
      if (priceDisplay) new MutationObserver(syncStickyAtc).observe(priceDisplay, { childList: true, subtree: true });

      stickyBtn.addEventListener('click', () => {
        if (!stickyBtn.disabled) atcButton.click(); // re-uses the real form submit + AJAX cart, untouched
      });

      if (atcWrap) {
        // Show whenever the customer is BELOW the real ATC button, hide when
        // above it — and check it TWO ways so a fast scroll can never miss it:
        //   1) IntersectionObserver (efficient), 2) a throttled scroll fallback.
        const updateStickyBar = () => {
          const show = atcWrap.getBoundingClientRect().bottom < 0; // ATC scrolled above the top = we're below it
          stickyBar.classList.toggle('is-visible', show);
          stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(updateStickyBar, { threshold: 0 }).observe(atcWrap);
        }
        let ticking = false;
        window.addEventListener('scroll', () => {
          if (!ticking) { ticking = true; requestAnimationFrame(() => { updateStickyBar(); ticking = false; }); }
        }, { passive: true });
        updateStickyBar(); // set correct state on load
      }
    }
  } catch (e) { console.error('Sticky ATC Error:', e); }

  // === 3. EVENT LISTENERS (Clicks) ===

  document.body.addEventListener('click', (e) => {
    
    // --- MAIN GALLERY ARROWS ---
    const prevBtn = e.target.closest('#sircable-gallery-prev');
    const nextBtn = e.target.closest('#sircable-gallery-next');

    if (prevBtn || nextBtn) {
      e.preventDefault();
      if (mainGallery) { nextBtn ? mainGallery.next() : mainGallery.prev(); }
    }

    // --- LIGHTBOX ARROWS ---
    const lbPrevBtn = e.target.closest('#sircable-lightbox-prev, #sircable-lb-counter-prev');
    const lbNextBtn = e.target.closest('#sircable-lightbox-next, #sircable-lb-counter-next');

    if (lbPrevBtn || lbNextBtn) {
      e.preventDefault();
      lbStep(lbNextBtn ? 1 : -1);
    }

    // --- LIGHTBOX OPEN & SILENT PRELOADER ---
    const zoomBtn = e.target.closest('#sircable-zoom-trigger');
    if (zoomBtn) {
      e.preventDefault();
      const lb = document.getElementById('sircable-lightbox');
      if (lb) {
        lb.classList.add('is-open');
        window.SircableScrollLock.lock('lightbox');

        // Open on whatever image the product page is currently showing.
        // lbOpenAt() handles GPU pre-warming via img.decode() for all slides.
        const mainThumbs = Array.from(document.querySelectorAll('.product-gallery__thumb'));
        let start = mainThumbs.findIndex(t => t.classList.contains('is-active'));
        if (start === -1) start = 0;
        lbOpenAt(start);

        // The browser only re-evaluates the cursor on mouse-move, so after the
        // lightbox opens under a stationary pointer it keeps showing the glove.
        // Setting the cursor inline now forces an immediate switch to the
        // magnifier; the rAF hands it back to CSS (.is-open) which holds it.
        lb.style.cursor = "url('https://cdn.shopify.com/s/files/1/0763/6510/3241/files/magnifying_glass.png?v=1781655799') 41 56, url('https://cdn.shopify.com/s/files/1/0763/6510/3241/files/844ntitled_design_26_1.png?v=1779512449') 34 41, auto";
        requestAnimationFrame(function () { lb.style.cursor = ''; });
      }
    }

    // --- LIGHTBOX ZOOM TOGGLE ---
    if (e.target.closest('.sircable-lb-slide')) {
      e.preventDefault();
      if (sircableSwiped) { sircableSwiped = false; return; }
      const lbContainer = document.getElementById('sircable-lightbox-main');
      if (lbContainer) {
        // Zoom INTO the clicked point (magnifier feel), then mousemove pans
        if (!lbContainer.classList.contains('is-zoomed') && lbViewport) {
          const r = lbViewport.getBoundingClientRect();
          const ox = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width  * 100));
          const oy = Math.max(0, Math.min(100, (e.clientY - r.top)  / r.height * 100));
          lbContainer.style.setProperty('--lb-ox', ox + '%');
          lbContainer.style.setProperty('--lb-oy', oy + '%');
        }
        lbContainer.classList.toggle('is-zoomed');
      }
    }

    // --- SIZE CHART DRAWER OPEN ---
    const sizeBtn = e.target.closest('#sircable-size-chart-trigger');
    if (sizeBtn) {
      e.preventDefault();
      const sd = document.getElementById('sircable-size-drawer');
      if (sd) {
        sd.classList.add('is-open'); 
        window.SircableScrollLock.lock('sizedrawer');
      }
    }

    // --- CLOSING MODALS ---
    if (e.target.closest('#sircable-lightbox-close')) {
      const lb = document.getElementById('sircable-lightbox');
      if (lb) { lb.classList.remove('is-open'); lb.style.background = ''; lb.style.opacity = ''; lb.style.transition = ''; }
      window.SircableScrollLock.unlock('lightbox');
      if (lbMainEl) { lbMainEl.classList.remove('is-zoomed'); lbMainEl.style.transform = ''; lbMainEl.style.transition = ''; }
      lbSwipeDown = false; lbDragY = 0;
    }

    if (e.target.closest('#sircable-size-drawer-close') || e.target.closest('#sircable-size-drawer-bg')) {
      const sd = document.getElementById('sircable-size-drawer');
      if (sd) sd.classList.remove('is-open');
      window.SircableScrollLock.unlock('sizedrawer');
    }

    // --- SWATCHES & THUMBNAILS (MAIN) ---
    const thumb = e.target.closest('.product-gallery__thumb');
    if (thumb) {
      e.preventDefault();
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      
      const newSrc = thumb.getAttribute('data-src');
      updateMainImage(newSrc);
      
      if (productVariants.length > 0 && newSrc) {
        const targetBase = newSrc.split('?')[0];
        const matchedVariant = productVariants.find(v => v.featured_image && v.featured_image.src && v.featured_image.src.includes(targetBase));
        if (matchedVariant) {
           optionContainers.forEach(container => {
              const optName = container.getAttribute('data-option-name'); 
              const rawName = container.getAttribute('data-raw-name');
              const variantVal = matchedVariant[optName];
              
              if (variantVal && rawName && rawName.includes('color')) {
                const buttons = container.querySelectorAll('.product-option__btn');
                buttons.forEach(b => b.classList.remove('is-active'));
                const btnToClick = Array.from(buttons).find(b => b.getAttribute('data-value') === variantVal);
                if (btnToClick) {
                  btnToClick.classList.add('is-active');
                  const targetLabel = document.getElementById(btnToClick.dataset.target);
                  if (targetLabel) targetLabel.textContent = variantVal;
                }
              }
           });
           updateVariantSelections();
        }
      }
    }

    // --- SWATCHES (VARIANTS) ---
    const optBtn = e.target.closest('.product-option__btn');
    if (optBtn) {
      e.preventDefault();
      const parent = optBtn.closest('.product-option__values');
      if (parent) {
        parent.querySelectorAll('.product-option__btn').forEach(b => b.classList.remove('is-active'));
        optBtn.classList.add('is-active');
        const targetId = optBtn.dataset.target;
        if (targetId) document.getElementById(targetId).textContent = optBtn.dataset.value;
        updateVariantSelections();

        // Mobile: jump to the product photo so the customer sees the colour they picked
        const swatchRawName = parent.getAttribute('data-raw-name') || '';
        if (swatchRawName.indexOf('color') !== -1 && window.innerWidth <= 768) {
          const stage = document.getElementById('main-image-container');
          if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    // --- LIGHTBOX THUMBNAILS ---
    const lbThumb = e.target.closest('.sircable-lightbox__thumb');
    if (lbThumb) {
      e.preventDefault();
      lbGoToReal(parseInt(lbThumb.getAttribute('data-index'), 10) || 0, true);
    }
  });
});